import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiShield } from 'react-icons/fi';
import toast from 'react-hot-toast';
import axios from '../utils/axios';
import useAuthStore from '../store/useAuthStore';

const Verify2FA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginSuccess } = useAuthStore();
  const email = location.state?.email;

  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error('E-posta adresi bulunamadı');
      navigate('/login');
      return;
    }

    if (code.length !== 6) {
      toast.error('Lütfen 6 haneli kodu girin');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post('/auth/verify2fa', { email, code });
      
      if (response.data.success) {
        // loginSuccess kullan (token'ı localStorage'a kaydet)
        loginSuccess(response.data.data);
        
        toast.success('Giriş başarılı');
        
        // Kullanıcı rolüne göre yönlendir
        const redirectUrl = location.state?.redirect || '/';
        if (response.data.data.role === 'admin') {
          navigate('/admin/dashboard');
        } else {
          navigate(redirectUrl);
        }
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Geçersiz kod');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-primary-100 rounded-full flex items-center justify-center mb-4">
            <FiShield className="h-8 w-8 text-primary-600" />
          </div>
          <h2 className="text-3xl font-serif font-light text-gray-900">
            İki Faktörlü Doğrulama
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            E-posta adresinize gönderilen 6 haneli kodu girin
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="code" className="block text-sm font-medium text-gray-700 mb-1">
              Doğrulama Kodu
            </label>
            <input
              id="code"
              name="code"
              type="text"
              required
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              className="input-field text-center text-2xl tracking-widest"
              placeholder="000000"
            />
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
            >
              {loading ? 'Doğrulanıyor...' : 'Doğrula'}
            </button>
          </div>

          <div className="text-center text-sm text-gray-600">
            <p>Kod gelmedi mi?</p>
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Giriş sayfasına dön
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Verify2FA;

